<app-progress-bar-loader [loadingText]="'Your report is getting generated,\n Please wait.'" *ngIf="isLoading&&!exportUI"></app-progress-bar-loader>

<div class="flyout-message" *ngIf="showCopyMessage" [@fadeInOut]>
    Copied Successfully
</div>

<ng-container *ngIf="!exportUI&&!isLoading">
    <div class="sniff-report-heading-container">
        <div class="sniff-report-heading">
            Sniff Test Report
        </div>
        <div class="sniff-report-controls" *ngIf="!shareReport">
            <!-- <button class="primary-button" (click)="onSaveReport()">
                Save Report
            </button> -->
            <button class="cancel-button" (click)="cancelClickDefault()">
                Close
            </button>
            <button class="export-button" (click)="toggleShareMenu()">Share</button>
        </div>
        <!-- Share & Close Buttons
        <div style="display: flex; justify-content: flex-end; gap: 10px; margin-bottom: 16px;">
            <button mat-stroked-button color="warn">Close</button>
            <button mat-flat-button color="accent" (click)="toggleShareMenu()">
      Share
    </button>
        </div> -->

        <!-- Share Menu Flyout -->

        <!-- Share Menu Flyout -->
        <div *ngIf="showShareMenu" class="share-menu-native" appClickOutside (clickOutside)="clickoutside($event)">

            <!-- Export as PDF -->
            <div class="menu-item" (click)="exportPDF()">
                <mat-icon>picture_as_pdf</mat-icon>
                <span class="menu-label">Export as PDF</span>
            </div>

            <hr />

            <!-- Shareable Link -->
            <div class="menu-item link-section">
                <mat-icon>link</mat-icon>
                <span class="menu-label">Shareable Link</span>
            </div>

            <!-- Link + Copy -->
            <div class="link-box">

                <!-- Loading State -->
                <mat-spinner *ngIf="loadingLink" diameter="24"></mat-spinner>

                <!-- Link Display -->
                <ng-container *ngIf="!loadingLink">
                    <input class="link-input" [value]="shareableLink" (copy)="onCopy()" readonly />
                    <button class="copy-btn" (click)="copyLink()">Copy</button>
                </ng-container>

            </div>
        </div>

    </div>

    <div class="sniff-tab-bar">
        <div class="sniff-tab " *ngIf="validitySkip||infringeOrFullReport" [class.sniff-active-tab]="currentTab=='industry'" (click)="currentTab='industry'">Infringe Fusion</div>
        <div class="sniff-tab" *ngIf="!validitySkip" [class.sniff-active-tab]="currentTab=='pas'" (click)="currentTab='pas'">Invalidity Check</div>
        <!-- <div class="sniff-tab" [class.sniff-active-tab]="currentTab=='infringement'" (click)="currentTab='infringement'">Infringement Assessment</div> -->

    </div>

    <div class="sniff-tab-content-wrapper" *ngIf="selectedPatentIndex==null">
        <div *ngIf="currentTab=='industry'" class="sniff-tab-content industry-report">
            <div *ngIf="currentReportMode=='full'" class="industry-report-widgets">
                <div class="industry-report-widget widget-blue">
                    <div class="widget-heading">
                        Patents
                    </div>
                    <div class="widget-main-text">
                        {{industryData.length}}
                    </div>
                    <div class="widget-sub-text">
                        US Patents
                    </div>
                </div>
                <div class="industry-report-widget widget-green" *ngIf="!validitySkip">
                    <div class="widget-heading">
                        Invalidity
                    </div>
                    <div class="widget-main-text">
                        {{getValidityScoreCount()}}
                    </div>
                    <div class="widget-sub-text">
                        Patents with more than 7 Invalidity Score
                    </div>
                </div>
                <div class="industry-report-widget widget-yellow">
                    <div class="widget-heading">
                        Damage
                    </div>
                    <div class="widget-main-text">
                        {{getRevenueDetails()}}

                    </div>
                    <div class="widget-sub-text">
                        Estimated Revenue
                    </div>
                </div>
                <div class="industry-report-widget widget-red">
                    <div class="widget-heading">
                        Infringement Companies
                    </div>
                    <div class="widget-main-text">
                        {{infringementArray.length}}
                    </div>
                    <div class="widget-sub-text">
                        No. of infringed companies
                    </div>
                </div>
            </div>
            <div *ngIf="currentReportMode=='infringement'" class="industry-report-widgets">
                <div class="industry-report-widget widget-blue">
                    <div class="widget-heading">
                        Total Patents
                    </div>
                    <div class="widget-main-text">
                        {{industryData.length}}
                    </div>
                    <div class="widget-sub-text">
                        US Patents
                    </div>
                </div>

                <div class="industry-report-widget widget-green">
                    <div class="widget-heading">
                        Total Damage Value
                    </div>
                    <div class="widget-main-text">
                        {{getRevenueDetails()}}

                    </div>
                    <div class="widget-sub-text">
                        Estimated Revenue
                    </div>
                </div>
                <div class="industry-report-widget widget-yellow">
                    <div class="widget-heading">
                        Medium Infringe Level
                    </div>
                    <div class="widget-main-text">
                        {{ getInfringementStats().midCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patents within score range 4-6
                    </div>
                </div>
                <div class="industry-report-widget widget-red">
                    <div class="widget-heading">
                        High Infringe Level
                    </div>
                    <div class="widget-main-text">
                        {{ getInfringementStats().highCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patents within score range 7-10
                    </div>
                </div>
            </div>
            <div class="industry-table">
                <table>
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Patent Number</th>
                            <!-- <th>Current Assignee</th> -->
                            <th>Targeted Company</th>
                            <th>Company Revenue</th>
                            <th>Targeted Product</th>
                            <th>Product Revenue</th>
                            <th>Damage</th>
                            <th>Infringement Score</th>
                            <!-- <th>Product Revenue</th> -->
                            <!-- <th>Global Headquarters</th> -->
                            <!-- <th>US Headquarters</th> -->
                            <!-- <th>State of Incorporation</th> -->
                            <th>Report</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let patent of industryData; let i = index">
                            <ng-container *ngIf="infringementData['patentInfringementScoreData'][patent.patentNumber]!=0">
                                <td>{{ i + 1 }}</td>
                                <td>
                                    <!-- {{ patent.patentNumber }} -->
                                    <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                            {{ patent.patentNumber  }}
                        </a>
                                </td>
                                <!-- <td>{{patent.currentAssignee}}</td> -->
                                <td>
                                    <ng-container *ngFor="let company of patent.companies">
                                        <div appTruncateTextWidth>
                                            {{ company.name }}
                                            <ngx-popover>
                                                <button class="sources-button">
                                        <img src="assets/images/link-icon.png" alt="info" />
                                    </button>

                                                <ng-template ngx-popover-template>
                                                    <div class="sources-content">
                                                        Source: <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                                                https://patents.google.com/patent/{{ patent.patentNumber  }}
                                            </a>
                                                    </div>
                                                </ng-template>

                                                <!-- <ngx-arrow padding="8" /> -->
                                            </ngx-popover>
                                        </div>
                                        <ng-container *ngFor="let product of company.products;let k= index">
                                            <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngFor="let company of patent.companies">

                                        <div class="revenue-edit-controls">

                                            <div appTruncateTextWidth>
                                                {{ company.companyInfo.Revenue.response }}
                                                <ngx-popover>
                                                    <button class="sources-button">
                                            <img src="assets/images/link-icon.png" alt="info" />
                                        </button>

                                                    <ng-template ngx-popover-template>
                                                        <div class="sources-content">
                                                            Source: <span [innerHTML]="getLinkOrAiEstimate(company.companyInfo.Revenue.sourceLink)"></span>
                                                        </div>
                                                    </ng-template>

                                                    <!-- <ngx-arrow padding="8" /> -->
                                                </ngx-popover>
                                                <!-- <button mat-icon-button (click)="openFileUploadPopup(patent.patentNumber, '', company.name)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
                    </button> -->
                                            </div>

                                        </div>


                                        <ng-container *ngFor="let product of company.products;let k= index">
                                            <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                </td>
                                <td>
                                    <ng-container *ngFor="let company of patent.companies">
                                        <ng-container *ngFor="let product of company.products;let ind=index">

                                            <div [class.last-item]="ind==company.products.length-1" appTruncateTextWidth>
                                                {{ product.name }}
                                                <ngx-popover>
                                                    <button class="sources-button">
                                            <img src="assets/images/link-icon.png" alt="info" />
                                        </button>

                                                    <ng-template ngx-popover-template>
                                                        <div class="sources-content">
                                                            Source: <span [innerHTML]="getLinkOrAiEstimate(product.sourceLink)"></span>
                                                        </div>
                                                    </ng-template>

                                                    <!-- <ngx-arrow padding="8" /> -->
                                                </ngx-popover>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </td>

                                <td>
                                    <ng-container *ngFor="let company of patent.companies">
                                        <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">

                                            <div [class.last-item]="ind==company.products.length-1" appTruncateTextWidth>
                                                {{ product.revenue.response }}
                                                <ngx-popover>
                                                    <button class="sources-button">
                                            <img src="assets/images/link-icon.png" alt="info" />
                                        </button>

                                                    <ng-template ngx-popover-template>
                                                        <div class="sources-content">
                                                            Source: <span [innerHTML]="getLinkOrAiEstimate(product.revenue.sourceLink)"></span>
                                                        </div>
                                                    </ng-template>

                                                </ngx-popover>
                                                <!-- {{product.revenue?.response?.length}} -->
                                            </div>

                                        </div>
                                    </ng-container>
                                </td>
                                <td>
                                    <span>{{getRevenueSumDetails(patent)}}</span>
                                </td>
                                <td>
                                    <app-validity-score [score]="infringementData['patentInfringementScoreData'][patent.patentNumber]" [infringementScore]="true"></app-validity-score>
                                </td>
                                <td>
                                    <a class="view-report-link" (click)="setSelectedPatentIndex(patent.patentNumber)">View Report</a>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="infringementData['patentInfringementScoreData'][patent.patentNumber]==0">
                                <td>{{ i + 1 }}</td>
                                <td>
                                    <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                            {{ patent.patentNumber  }}
                        </a>
                                </td>
                                <td>No infringe company found</td>
                                <td>-</td>
                                <td>No infringe product found</td>
                                <td>-</td>
                                <td>-</td>
                                <td>
                                    <app-validity-score [score]="infringementData['patentInfringementScoreData'][patent.patentNumber]" [infringementScore]="true"></app-validity-score>
                                </td>
                                <td>
                                    <a class="view-report-link" (click)="setSelectedPatentIndex(patent.patentNumber)">View Report</a>
                                </td>

                            </ng-container>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div *ngIf="currentTab=='pas'" class="sniff-tab-content pas-report">
            <div class="industry-report-widgets">
                <!-- Total Patents -->
                <div class="industry-report-widget widget-blue">
                    <div class="widget-heading">Total Patents</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().total }}
                    </div>
                    <div class="widget-sub-text">
                        US Patents
                    </div>
                </div>

                <!-- Low Invalidity Level -->
                <div class="industry-report-widget widget-green">
                    <div class="widget-heading">Low Invalidity Level</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().lowCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patent within score range 1-3
                    </div>
                </div>

                <!-- Medium Invalidity Level -->
                <div class="industry-report-widget widget-yellow">
                    <div class="widget-heading">Medium Invalidity Level</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().midCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patent within score range 4-6
                    </div>
                </div>

                <!-- High Invalidity Level -->
                <div class="industry-report-widget widget-red">
                    <div class="widget-heading">High Invalidity Level</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().highCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patent within score range 7-10
                    </div>
                </div>
            </div>
            <div class="pas-table">
                <div class="legend-flex-end">
                    <app-score-legend [validityScore]="true"></app-score-legend>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Patent Number</th>
                            <th>Title</th>
                            <th>Current Assignee</th>
                            <th>Invalidity Score</th>
                            <th>Report</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let patent of validityData.summaryData; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ patent.patentNumber }}</td>
                            <td>{{patent.title}}</td>
                            <td>{{patent.assignee}}</td>
                            <td>
                                <app-validity-score [score]="patent.score"></app-validity-score>
                            </td>
                            <td>
                                <a class="view-report-link" (click)="setSelectedPatentIndex(patent.patentNumber)">View Report</a>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div *ngIf="currentTab=='infringement'" class="sniff-tab-content infringement-report">
            <div class="infringement-table">
                <div class="legend-flex-end">
                    <app-score-legend></app-score-legend>
                </div>
                <!-- <table>
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Patent Number</th>
                            <th>Title</th>
                            <th>Priority Date</th>
                            <th>Current Assignee</th>
                            <th>Invalidity Score</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let patent of validityData; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ patent.patentNumber }}</td>
                            <td>Automated cinematic decisions based on descriptive models</td>
                            <td>2019-01-01</td>
                            <td>Cilag GmbH International</td>
                            <td>8</td>
                        </tr>
                    </tbody>
                </table> -->
                <table>
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Patent Number</th>
                            <th>Targeted Company</th>
                            <th>Targeted Product</th>
                            <th>Infringement Score</th>
                            <th>Report</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let patent of infringementArray; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ patent.patentNumber }}</td>
                            <td>
                                <ng-container *ngFor="let company of patent.companies">
                                    <div appTruncateTextWidth>
                                        {{ company.name }}
                                    </div>
                                    <ng-container *ngFor="let product of company.products;let k= index">
                                        <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </td>

                            <td>
                                <ng-container *ngFor="let company of patent.companies">
                                    <ng-container *ngFor="let product of company.products;let ind=index">

                                        <div appTruncateTextWidth [class.last-item]="ind==company.products.length-1">
                                            {{ product.name }}
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </td>
                            <td>
                                <app-validity-score [score]="infringementData['patentInfringementScoreData'][patent.patentNumber]" [infringementScore]="true"></app-validity-score>
                            </td>
                            <td>
                                <a class="view-report-link" (click)="setSelectedPatentIndex(patent.patentNumber)">View Report</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</ng-container>
<!-- <ng-container *ngIf="!exportUI&&!selectedPatentIndex"> -->

<div class="major-report-wrapper" id="major-report" *ngIf="selectedPatentIndex!=null">
    <div class="major-report-header">
        <button class="back-button" (click)="backIndex()">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.0026 25.6654C20.4459 25.6654 25.6693 20.442 25.6693 13.9987C25.6693 7.55538 20.4459 2.33203 14.0026 2.33203C7.55928 2.33203 2.33594 7.55538 2.33594 13.9987C2.33594 20.442 7.55928 25.6654 14.0026 25.6654Z" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.0026 9.33203L9.33594 13.9987L14.0026 18.6654" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M18.6693 14H9.33594" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
            </button>
        <div class="patent-title-and-controls">
            <div class="left-button" (click)="changeIndex(-1)">
                <svg width="9" height="19" viewBox="0 0 9 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-4.5897e-07 9.5L9 0.406734L9 18.5933L-4.5897e-07 9.5Z" fill="black"/>
                        </svg>

            </div>
            <div class="patent-title">
                {{inputData[selectedPatentIndex].patentNumber}}
            </div>
            <div class="right-button" (click)="changeIndex(1)">
                <svg width="9" height="19" viewBox="0 0 9 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 9.5L-8.56449e-07 18.5933L-6.14903e-08 0.406733L9 9.5Z" fill="black"/>
                        </svg>
            </div>
        </div>
        <div class="patent-index-information">
            ({{selectedPatentIndex + 1}}/{{inputData.length}})
        </div>
    </div>
    <div class="metadata-container">

        <div class="patent-metadata">
            <div class="key-value-pair">
                <div class="key">Patent Number</div>
                <div class="value">{{inputData[selectedPatentIndex].patentNumber}}</div>
            </div>
            <div class="key-value-pair">
                <div class="key">Priority Date</div>
                <div class="value">{{inputData[selectedPatentIndex].priorityDate}}</div>
            </div>
            <div class="key-value-pair">
                <div class="key">Current Assignee</div>
                <div class="value">{{inputData[selectedPatentIndex].currentAssignee}}</div>
            </div>
            <div class="key-value-pair">
                <div class="key">Expiration Date</div>
                <div class="value">{{inputData[selectedPatentIndex].expirationDate}}</div>
            </div>
            <div class="key-value-pair">
                <div class="key">Publication Date</div>
                <div class="value">{{inputData[selectedPatentIndex].publicationDate}}</div>
            </div>
            <!-- patent title -->
            <div class="key-value-pair">
                <div class="key">Title</div>
                <div class="value">{{inputData[selectedPatentIndex].title}}</div>
            </div>
        </div>
        <div class="infringement-score-container">
            <div class="infringement-score">
                <div class="infringement-score-heading">
                    <ng-container *ngIf="currentTab=='industry'">
                        Infringement Score
                    </ng-container>
                    <ng-container *ngIf="currentTab=='pas'">
                        Invalidity Score
                    </ng-container>
                    <ng-container *ngIf="currentTab=='infringement'">
                        Infringement Score
                    </ng-container>
                </div>
                <div class="infringement-score-value" [class.score-mid]="getScoreValue()>3" [class.score-high]="getScoreValue()>6">
                    <ng-container *ngIf="currentTab=='industry'">
                        {{infringementData['patentInfringementScoreData'][inputData[selectedPatentIndex].patentNumber]}}
                    </ng-container>
                    <ng-container *ngIf="currentTab=='pas'">
                        {{getValidityScore(inputData[selectedPatentIndex].patentNumber)}}
                    </ng-container>
                    <ng-container *ngIf="currentTab=='infringement'">
                        {{infringementData['patentInfringementScoreData'][inputData[selectedPatentIndex].patentNumber]}}
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
    <app-score-legend [validityScore]="currentReportMode=='pas'?true:false"></app-score-legend>
    <div class="key-value-pair">
        <div class="key">
            Technology in brief
        </div>
        <div class="value">
            {{inputData[selectedPatentIndex].technology}}
        </div>
    </div>
    <div class="key-value-sep" *ngIf="!validitySkip">
        <div class="key">
            Claims Considered
        </div>
        <div class="value">
            {{validityData.claimsConsideredMap[inputData[selectedPatentIndex].patentNumber]}}
        </div>
    </div>
    <div *ngIf="currentTab=='industry'" class="major-table-container">
        <div class="claim-charts-heading">
            <div class="claim-charts-heading-text">
                Claim Charts
            </div>
            <div class="expand-collapse-button" (click)="expandAllReferences()" [style]="{cursor:'pointer'}">

                <svg [style]="{
                transform: allExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 13L12 18L17 13" stroke="#FF5100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 6L12 11L17 6" stroke="#FF5100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <ng-container *ngIf="!allExpanded">
                    Expand
                </ng-container>
                <ng-container *ngIf="allExpanded">
                    Collapse
                </ng-container>

            </div>
        </div>
        <div *ngFor="let claimData of getNonZeroClaimCharts(getFilteredClaimChartData(inputData[selectedPatentIndex].patentNumber)); let i=index">
            <div class="claim-chart-iterable">

                <div class="claim-chart-iterable-heading">
                    {{claimData.patent_number}} vs. {{claimData.targeted_product}}
                    <div class="d-flex">
                        <button *ngIf="!shareReport" class="borderless-button" (click)="openEditDialog(claimData)"><svg width="24" height="24" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.4167 6.33337H6.33341C5.49356 6.33337 4.68811 6.667 4.09424 7.26087C3.50038 7.85473 3.16675 8.66019 3.16675 9.50004V31.6667C3.16675 32.5066 3.50038 33.312 4.09424 33.9059C4.68811 34.4997 5.49356 34.8334 6.33341 34.8334H28.5001C29.3399 34.8334 30.1454 34.4997 30.7393 33.9059C31.3331 33.312 31.6667 32.5066 31.6667 31.6667V20.5834" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M29.2917 3.95837C29.9216 3.32848 30.7759 2.97461 31.6667 2.97461C32.5575 2.97461 33.4119 3.32848 34.0417 3.95837C34.6716 4.58826 35.0255 5.44257 35.0255 6.33337C35.0255 7.22416 34.6716 8.07848 34.0417 8.70837L19.0001 23.75L12.6667 25.3334L14.2501 19L29.2917 3.95837Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button class=" borderless-button export-button" (click)="toggleClaimChartMenu(''+claimData.patent_number+i)"><svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26 20L26 23.3333C26 23.7754 25.8127 24.1993 25.4793 24.5118C25.1459 24.8244 24.6937 25 24.2222 25L11.7778 25C11.3063 25 10.8541 24.8244 10.5207 24.5118C10.1873 24.1993 10 23.7754 10 23.3333L10 20" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M22 15L18 11L14 15" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 11L18 21" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <circle cx="18" cy="18" r="16.5" stroke="black" stroke-width="3"/>
                            </svg>
                            </button>
                        <div *ngIf="showClaimChartMenu[''+claimData.patent_number+i]" class="share-menu-native share-menu-claimchart" appClickOutside (clickOutside)="clickOutsideShareMenu($event)">

                            <!-- Export as Docx -->
                            <div class="menu-item menu-item-greyed-out" (click)="exportPDFWithId(''+claimData.patent_number+' vs. '+claimData.targeted_product+i)">
                                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.00008 7.33333V12.3333M7.00008 12.3333L4.50008 9.83333M7.00008 12.3333L9.50008 9.83333M11.1667 16.5H2.83341C2.39139 16.5 1.96746 16.3244 1.6549 16.0118C1.34234 15.6993 1.16675 15.2754 1.16675 14.8333V3.16667C1.16675 2.72464 1.34234 2.30072 1.6549 1.98816C1.96746 1.67559 2.39139 1.5 2.83341 1.5H7.48842C7.70941 1.50005 7.92134 1.58788 8.07758 1.74417L12.5892 6.25583C12.7455 6.41208 12.8334 6.624 12.8334 6.845V14.8333C12.8334 15.2754 12.6578 15.6993 12.3453 16.0118C12.0327 16.3244 11.6088 16.5 11.1667 16.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                <span class="menu-label">Export as PDF</span>

                                <div class="coming-soon-label">Coming Soon</div>
                            </div>

                            <hr />
                            <!-- Export as PDF -->
                            <div class="menu-item" (click)="exportClaimChartToDocx(claimData)">
                                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.50008 9.83333H7.00012H9.50008M4.50012 12.8333H7.00016H9.50012M4.50012 6.83325H7.00016H9.50012M11.1667 16.5H2.83341C2.39139 16.5 1.96746 16.3244 1.6549 16.0118C1.34234 15.6993 1.16675 15.2754 1.16675 14.8333V3.16667C1.16675 2.72464 1.34234 2.30072 1.6549 1.98816C1.96746 1.67559 2.39139 1.5 2.83341 1.5H7.48842C7.70941 1.50005 7.92134 1.58788 8.07758 1.74417L12.5892 6.25583C12.7455 6.41208 12.8334 6.624 12.8334 6.845V14.8333C12.8334 15.2754 12.6578 15.6993 12.3453 16.0118C12.0327 16.3244 11.6088 16.5 11.1667 16.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                <span class="menu-label">Export as Word</span>
                            </div>
                        </div>
                        <div class="reference-arrow-container">

                            <button class="reference-arrow" [class.arrow-closed]="!referenceDivOpenMap(claimData.patent_number+''+i, i)" (click)="toggleReferenceDiv(claimData.patent_number+''+i)">
                            <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 11.5L11 2.5L2 11.5" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>
                <div class="reference-div-body" [class.body-open]="exportingState||referenceDivOpenMap(claimData.patent_number+''+i, i)">

                    <table>
                        <thead>
                            <tr>
                                <th>Claims</th>
                                <th>Infringement</th>
                                <th>Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let claimElement of claimData.data; let j=index">
                                <td>
                                    <div class="claim-element-td-container">
                                        {{claimElement.claim_element}}
                                    </div>
                                </td>
                                <td>
                                    <div class="claim-element-td-container">
                                        <div class="indvidual-part-claim-element">
                                            <b>Analyst Comment: </b> {{claimElement.analyst_comment}}
                                        </div>
                                        <ng-container *ngFor="let ref of claimElement.references; let i = index">
                                            <div class="individual-part-claim-element">
                                                <b>Reference {{ i + 1 }}:</b> {{ ref.reference }}
                                            </div>
                                            <div class="individual-part-claim-element" *ngIf="ref.source">
                                                <b>Source:</b>
                                                <span [innerHTML]="getLinkOrText(ref.source)"></span>
                                            </div>
                                            <div class="individual-part-claim-element" *ngIf="ref.relavanceIndex">
                                                <b>Similarity Grade:</b> {{roundFirstTenth(ref.relavanceIndex)}}%
                                            </div>
                                        </ng-container>

                                    </div>
                                </td>
                                <td>
                                    <div class="claim-element-td-container">
                                        <ng-container *ngIf="j==0">
                                            <app-validity-score [score]="claimData.score" [infringementScore]="true"></app-validity-score>
                                        </ng-container>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="other-targets-section" *ngIf="getZeroClaimCharts(getFilteredClaimChartData(inputData[selectedPatentIndex].patentNumber)).length>0">
            <div class="other-targets-heading">
                Other Potential Targets ({{getZeroClaimCharts(getFilteredClaimChartData(inputData[selectedPatentIndex].patentNumber)).length}})
            </div>
            <table>
                <thead>
                    <tr>
                        <!-- <th>S. No.</th> -->
                        <!-- <th>Patent Number</th> -->
                        <!-- <th>Current Assignee</th> -->
                        <th>Targeted Company</th>
                        <!-- <th>Company Revenue</th> -->
                        <th>Targeted Product</th>
                        <!-- <th>Product Revenue</th> -->
                        <!-- <th>Global Headquarters</th> -->
                        <!-- <th>US Headquarters</th> -->
                        <!-- <th>State of Incorporation</th> -->
                        <th>Tech Docs</th>
                    </tr>
                </thead>
                <tbody class="limited-div-container">
                    <tr *ngFor="let patent of getIndustryDataForClaimData(getZeroClaimCharts(getFilteredClaimChartData(inputData[selectedPatentIndex].patentNumber))); let i = index">
                        <!-- <td>{{ i + 1 }}</td> -->
                        <!-- <td>
                        <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                            {{ patent.patentNumber  }}
                        </a>
                    </td>
                    <td>{{patent.currentAssignee}}</td> -->
                        <td>
                            <ng-container *ngFor="let company of patent.companies">
                                <div>
                                    {{ company.name }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let k= index">
                                    <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </td>
                        <!-- <td>
                        <ng-container *ngFor="let company of patent.companies">

                            <div class="revenue-edit-controls">
                               
                                <div>
                                    {{ company.companyInfo.Revenue.response }}
                                   
                                </div>
                                <ng-container *ngIf="assistMode">
                                    <button *ngIf="company.showRevenue" class="img-icon-button" (click)="openPopup(patent.patentNumber, '', company.name)">
                    <img src="assets/images/edit-link-icon.png">
                </button>
                                    <button *ngIf="company.showRevenue" class="img-icon-button" (click)="openFileUploadPopup(patent.patentNumber, '', company.name)">
                    <img src="assets/images/upload-file-icon.png">
                </button>
                                </ng-container>
                            </div>


                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>

                    </td> -->
                        <td>
                            <ng-container *ngFor="let company of patent.companies">
                                <ng-container *ngFor="let product of company.products;let ind=index">

                                    <div [class.last-item]="ind==company.products.length-1">
                                        {{ product.name }}
                                    </div>
                                </ng-container>
                            </ng-container>
                        </td>
                        <!-- <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">
                             
                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.revenue.response }}
                                    
                                </div>
                               
                            </div>
                        </ng-container>
                    </td> -->

                        <td>
                            <ng-container *ngFor="let company of patent.companies">
                                <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">

                                    <div [class.last-item]="ind==company.products.length-1">
                                        <div *ngIf="product.technicalDocumentationLinks&&product.technicalDocumentationLinks.length>0" class="product-target-link" (click)="openLinksDialog(product)">
                                            <a class="black-underline"> Links ({{product.technicalDocumentationLinks.length}})</a>
                                        </div>
                                        <!-- case where no links  -->
                                        <div *ngIf="!product.technicalDocumentationLinks||product.technicalDocumentationLinks.length==0" class="product-target-link">
                                            Unkown
                                        </div>

                                        <!-- <ng-container *ngIf="product.revenue.response">
                                        {{product.revenue?.response?.length()}}
                                    </ng-container> -->
                                    </div>

                                </div>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


    </div>
    <div *ngIf="currentTab=='infringement'" class="major-table-container">
        <table>
            <thead>
                <tr>
                    <th>S. No.</th>
                    <th>Patent Number</th>
                    <th>Current Assignee</th>
                    <th>Targeted Company</th>
                    <th>Company Revenue</th>
                    <th>Targeted Product</th>
                    <th>Product Revenue</th>
                    <th>Global Headquarters</th>
                    <th>US Headquarters</th>
                    <th>State of Incorporation</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let patent of getFilteredIndustryData(inputData[selectedPatentIndex].patentNumber); let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ patent.patentNumber }}</td>
                    <td>{{patent.currentAssignee}}</td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div>
                                {{ company.name }}
                            </div>
                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">

                            <div class="revenue-edit-controls">

                                <div>
                                    {{ company.companyInfo.Revenue.response }}
                                    <!-- <button mat-icon-button (click)="openFileUploadPopup(patent.patentNumber, '', company.name)">
                    <mat-icon>edit</mat-icon>
                    </button> -->
                                </div>

                            </div>


                            <ng-container *ngFor="let product of company.products;let k= index">
                                <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>

                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngFor="let product of company.products;let ind=index">

                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.name }}
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">

                                <div [class.last-item]="ind==company.products.length-1">
                                    {{ product.revenue.response }}
                                    <!-- <ng-container *ngIf="product.revenue.response">
                                        {{product.revenue?.response?.length()}}
                                    </ng-container> -->
                                </div>
                            </div>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies; let j=index">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["Global Headquarters"]["response"] }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let i= index">
                                    <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies; let j=index">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["US Headquarters"]["response"] }}
                                </div>
                            </ng-container>
                            <ng-container *ngFor="let product of company.products;let i= index">
                                <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container *ngFor="let company of patent.companies">
                            <ng-container *ngIf="company.new!=true">
                                <div>

                                    {{ company.companyInfo["State of Incorporation"]["response"] }}
                                </div>
                                <ng-container *ngFor="let product of company.products;let i= index">
                                    <div *ngIf="i!=0" [class.last-item]="i==company.products.length-1">
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="currentTab=='pas'" class="major-table-container">
        <div>
            <div class="claim-charts-heading">
                <div class="claim-charts-heading-text">
                    References
                </div>
                <div class="expand-collapse-button" (click)="toggleAllPasReferences()" [style]="{cursor:'pointer'}">

                    <svg [style]="{
                    transform: !allExpandedPas ? 'rotate(180deg)' : 'rotate(0deg)',
                    }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 13L12 18L17 13" stroke="#FF5100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 6L12 11L17 6" stroke="#FF5100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <ng-container *ngIf="allExpandedPas">
                        Expand
                    </ng-container>
                    <ng-container *ngIf="!allExpandedPas">
                        Collapse
                    </ng-container>

                </div>
            </div>
            <div *ngFor="let referenceTable of validityData.referenceTableMap[inputData[selectedPatentIndex].patentNumber]; let j=index" class="reference-table-container">
                <div class="reference-table-header-container">
                    <div class="reference-table-header">
                        Reference {{j+1}} {{referenceTable.referenceTitle}}
                    </div>
                    <button class="reference-table-arrow" [class.arrow-closed]="!referenceTableOpenMap(inputData[selectedPatentIndex].patentNumber, j, j)" (click)="toggleReferenceTable(inputData[selectedPatentIndex].patentNumber, j)">
                        <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 11.5L11 2.5L2 11.5" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            
                    </button>
                </div>
                <div class="reference-table-body" [class.body-open]="!referenceTableOpenMap(inputData[selectedPatentIndex].patentNumber, j, j)">
                    <table>
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>Independent Claim Elements</th>
                                <th>Mapping with <a href="https://patents.google.com/patent/{{inputData[selectedPatentIndex].patentNumber}}" target="_blank"><u>{{inputData[selectedPatentIndex].patentNumber}}</u></a></th>
                                <th>AI Comment</th>
                                <th>Invalidity Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let claim of referenceTable.claimElements; let k=index">
                                <td>{{k+1}}</td>
                                <td>
                                    <div class="claim-element-td-container">
                                        {{claim.claim_element}}
                                    </div>
                                </td>
                                <td>
                                    <div class="claim-element-td-container">
                                        {{claim.overlap}}
                                    </div>
                                </td>
                                <td>
                                    <div class="claim-element-td-container">
                                        {{claim.ai_comment}}
                                    </div>
                                </td>
                                <td>
                                    <div class="claim-element-td-container" *ngIf="k==0">
                                        <!-- {{claim.validity_score||0}} -->
                                        <app-validity-score [score]="claim.score||0"></app-validity-score>
                                    </div>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td>1</td>
                                <td>
                                    <div class="claim-element-td-container">
                                        A method for providing a positioning-assisting signal to a positioning engine, the method comprising:
                                    </div>
                                </td>
                                <td>
                                    Full Overlap
                                </td>
                                <td>
                                    the input sources comprising: one or more cameras, one or more microphones.
                                </td>
                                <td>
                                    7
                                </td>
                            </tr> -->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- </ng-container> -->
<div *ngIf="exportingState" class="exporting-overlay">
    <div class="exporting-overlay-content">
        <div class="exporting-overlay-heading">
            Exporting Report
        </div>
        <div class="exporting-overlay-text">
            Please wait while we export the report for you.
        </div>
        <div class="exporting-overlay-loader">
            <div class="loader"></div>
        </div>
    </div>
</div>
<div class="exportable-ui" id="exportable-ui" *ngIf="exportUI">
    <div class="lumenci-header" *ngIf="exportingState">
        <div class="lumenci-logo">
            <img src="assets/images/lumenci-logo.png" alt="Lumenci Logo">
        </div>
    </div>
    <div class="sniff-report-heading-container">
        <div class="sniff-report-heading">
            Sniff Test Report
        </div>
        <div class="sniff-report-controls" *ngIf="!exportingState">
            <button class="export-button" (click)="exportPDF()">Export</button>
            <button class="back-button"><svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1044_8739)">
                <path d="M36.8262 37.1449C42.909 31.1216 42.9572 21.3077 36.9339 15.2249C30.9106 9.14211 21.0966 9.09392 15.0139 15.1172C8.93107 21.1406 8.88287 30.9545 14.9062 37.0373C20.9295 43.1201 30.7435 43.1683 36.8262 37.1449Z" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 22L30.9567 30.9567" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 30.957L30.9567 22.0003" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_1044_8739">
                <rect width="38" height="38" fill="white" transform="translate(0 27) rotate(-45)"/>
                </clipPath>
                </defs>
                </svg>
                </button>
        </div>
    </div>

    <!-- <div class="sniff-tab-bar"> -->
    <div class="sniff-tab " *ngIf="currentReportMode=='full'||currentReportMode=='infringement'" [class.sniff-active-tab]="true" (click)="currentTab='industry'">Infringe Fusion</div>

    <!-- </div> -->

    <div class="sniff-tab-content-wrapper">
        <div class="sniff-tab-content industry-report">

            <div *ngIf="currentReportMode=='full'" class="industry-report-widgets">
                <div class="industry-report-widget widget-blue">
                    <div class="widget-heading">
                        Patents
                    </div>
                    <div class="widget-main-text">
                        {{industryData.length}}
                    </div>
                    <div class="widget-sub-text">
                        US Patents
                    </div>
                </div>
                <div class="industry-report-widget widget-red" *ngIf="!validitySkip">
                    <div class="widget-heading">
                        Invalidity
                    </div>
                    <div class="widget-main-text">
                        {{getValidityScoreCount()}}
                    </div>
                    <div class="widget-sub-text">
                        Patents with more than 7 Invalidity Score
                    </div>
                </div>
                <div class="industry-report-widget widget-yellow">
                    <div class="widget-heading">
                        Damage
                    </div>
                    <div class="widget-main-text">
                        {{getRevenueDetails()}}
                    </div>
                    <div class="widget-sub-text">
                        Estimated Revenue
                    </div>
                </div>
                <div class="industry-report-widget widget-green">
                    <div class="widget-heading">
                        Infringement Companies
                    </div>
                    <div class="widget-main-text">
                        {{infringementArray.length}}
                    </div>
                    <div class="widget-sub-text">
                        No. of infringed companies
                    </div>
                </div>
            </div>
            <div *ngIf="currentReportMode=='pas'" class="industry-report-widgets">
                <div class="industry-report-widget widget-blue">
                    <div class="widget-heading">Total Patents</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().total }}
                    </div>
                    <div class="widget-sub-text">
                        US Patents
                    </div>
                </div>

                <!-- Low Invalidity Level -->
                <div class="industry-report-widget widget-green">
                    <div class="widget-heading">Low Invalidity Level</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().lowCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patent within score range 1-3
                    </div>
                </div>

                <!-- Medium Invalidity Level -->
                <div class="industry-report-widget widget-yellow">
                    <div class="widget-heading">Medium Invalidity Level</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().midCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patent within score range 4-6
                    </div>
                </div>

                <!-- High Invalidity Level -->
                <div class="industry-report-widget widget-red">
                    <div class="widget-heading">High Invalidity Level</div>
                    <div class="widget-main-text">
                        {{ getInvalidityStats().highCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patent within score range 7-10
                    </div>
                </div>
            </div>
            <div *ngIf="currentReportMode=='infringement'" class="industry-report-widgets">
                <div class="industry-report-widget widget-blue">
                    <div class="widget-heading">
                        Total Patents
                    </div>
                    <div class="widget-main-text">
                        {{industryData.length}}
                    </div>
                    <div class="widget-sub-text">
                        US Patents
                    </div>
                </div>

                <div class="industry-report-widget widget-green">
                    <div class="widget-heading">
                        Total Damage Value
                    </div>
                    <div class="widget-main-text">
                        {{getRevenueDetails()}}

                    </div>
                    <div class="widget-sub-text">
                        Estimated Revenue
                    </div>
                </div>
                <div class="industry-report-widget widget-yellow">
                    <div class="widget-heading">
                        Medium Infringe Level
                    </div>
                    <div class="widget-main-text">
                        {{ getInfringementStats().midCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patents within score range 4-6
                    </div>
                </div>
                <div class="industry-report-widget widget-red">
                    <div class="widget-heading">
                        High Infringe Level
                    </div>
                    <div class="widget-main-text">
                        {{ getInfringementStats().highCount }}
                    </div>
                    <div class="widget-sub-text">
                        Patents within score range 7-10
                    </div>
                </div>
            </div>
            <div *ngIf="currentReportMode=='infringement'||currentReportMode=='full'" class="sniff-tab-content infringement-report">
                <div class="infringement-table">
                    <div class="legend-flex-end">
                        <app-score-legend></app-score-legend>
                    </div>
                    <!-- <table>
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>Patent Number</th>
                                <th>Title</th>
                                <th>Priority Date</th>
                                <th>Current Assignee</th>
                                <th>Invalidity Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let patent of validityData; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ patent.patentNumber }}</td>
                                <td>Automated cinematic decisions based on descriptive models</td>
                                <td>2019-01-01</td>
                                <td>Cilag GmbH International</td>
                                <td>8</td>
                            </tr>
                        </tbody>
                    </table> -->
                    <table>
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>Patent Number</th>
                                <!-- <th>Current Assignee</th> -->
                                <th>Targeted Company</th>
                                <th>Company Revenue</th>
                                <th>Targeted Product</th>
                                <th>Product Revenue</th>
                                <th>Damage</th>
                                <th>Infringement Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let patent of infringementArray; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>
                                    {{ patent.patentNumber }}
                                </td>
                                <!-- <td>{{patent.currentAssignee}}</td> -->
                                <td>
                                    <ng-container *ngFor="let company of patent.companies">
                                        <div>
                                            {{ company.name }}
                                            <ngx-popover>
                                                <button class="sources-button">
                                            <img src="assets/images/link-icon.png" alt="info" />
                                        </button>

                                                <ng-template ngx-popover-template>
                                                    <div class="sources-content">
                                                        Source: <a href="https://patents.google.com/patent/{{ patent.patentNumber }}" target="_blank">
                                                    https://patents.google.com/patent/{{ patent.patentNumber  }}
                                                </a>
                                                    </div>
                                                </ng-template>

                                                <!-- <ngx-arrow padding="8" /> -->
                                            </ngx-popover>
                                        </div>
                                        <ng-container *ngFor="let product of company.products;let k= index">
                                            <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngFor="let company of patent.companies">

                                        <div class="revenue-edit-controls">

                                            <div>
                                                {{ company.companyInfo.Revenue.response }}
                                                <ngx-popover>
                                                    <button class="sources-button">
                                                <img src="assets/images/link-icon.png" alt="info" />
                                            </button>

                                                    <ng-template ngx-popover-template>
                                                        <div class="sources-content">
                                                            Source: <span [innerHTML]="getLinkOrAiEstimate(company.companyInfo.Revenue.sourceLink)"></span>
                                                        </div>
                                                    </ng-template>

                                                    <!-- <ngx-arrow padding="8" /> -->
                                                </ngx-popover>
                                                <!-- <button mat-icon-button (click)="openFileUploadPopup(patent.patentNumber, '', company.name)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.5 2.49998C18.8978 2.10216 19.4374 1.87866 20 1.87866C20.5626 1.87866 21.1022 2.10216 21.5 2.49998C21.8978 2.89781 22.1213 3.43737 22.1213 3.99998C22.1213 4.56259 21.8978 5.10216 21.5 5.49998L12 15L8 16L9 12L18.5 2.49998Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
                        </button> -->
                                            </div>

                                        </div>


                                        <ng-container *ngFor="let product of company.products;let k= index">
                                            <div *ngIf="k!=0" [class.last-item]="k==company.products.length-1">
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                </td>
                                <td>
                                    <ng-container *ngFor="let company of patent.companies">
                                        <ng-container *ngFor="let product of company.products;let ind=index">

                                            <div [class.last-item]="ind==company.products.length-1">
                                                {{ product.name }}
                                                <ngx-popover>
                                                    <button class="sources-button">
                                                <img src="assets/images/link-icon.png" alt="info" />
                                            </button>

                                                    <ng-template ngx-popover-template>
                                                        <div class="sources-content">
                                                            Source: <span [innerHTML]="getLinkOrAiEstimate(product.sourceLink)"></span>
                                                        </div>
                                                    </ng-template>

                                                    <!-- <ngx-arrow padding="8" /> -->
                                                </ngx-popover>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </td>

                                <td>
                                    <ng-container *ngFor="let company of patent.companies">
                                        <div class="revenue-edit-controls" *ngFor="let product of company.products;let ind=index">

                                            <div [class.last-item]="ind==company.products.length-1">
                                                {{ product.revenue.response }}
                                                <ngx-popover>
                                                    <button class="sources-button">
                                                <img src="assets/images/link-icon.png" alt="info" />
                                            </button>

                                                    <ng-template ngx-popover-template>
                                                        <div class="sources-content">
                                                            Source: <span [innerHTML]="getLinkOrAiEstimate(product.revenue.sourceLink)"></span>
                                                        </div>
                                                    </ng-template>

                                                </ngx-popover>
                                                <!-- {{product.revenue?.response?.length}} -->
                                            </div>

                                        </div>
                                    </ng-container>
                                </td>
                                <td>
                                    <span>{{getRevenueSumDetails(patent)}}</span>
                                </td>
                                <td>
                                    <ng-container>
                                        <app-validity-score [score]="infringementData['patentInfringementScoreData'][patent.patentNumber]" [infringementScore]="true"></app-validity-score>
                                    </ng-container>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <ng-container *ngIf="!validitySkip">

            <div class="sniff-tab" [class.sniff-active-tab]="true" (click)="currentTab='pas'">Invalidity Check</div>

            <div class="sniff-tab-content pas-report">
                <div class="pas-table">
                    <div class="legend-flex-end">
                        <app-score-legend [validityScore]="true"></app-score-legend>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>Patent Number</th>
                                <th>Title</th>
                                <th>Current Assignee</th>
                                <th>Invalidity Score</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let patent of validityData.summaryData; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ patent.patentNumber }}</td>
                                <td>{{patent.title}}</td>
                                <td>{{patent.assignee}}</td>
                                <td>
                                    <app-validity-score [score]="patent.score"></app-validity-score>

                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>


    </div>
</div>